import { createFileRoute } from "@tanstack/react-router";

import { FeaturePage } from "@/components/site/FeaturePage";
import { featurePage } from "@/content/features";
import { normalizeLocale } from "@/lib/i18n";
import { pageHead } from "@/content/seo-pages";
import { faqScript } from "@/lib/faq-schema";

export const Route = createFileRoute("/{-$locale}/stocks")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const seo = featurePage("stocks").seo;
    const head = pageHead("/stocks", locale, { title: seo.title, description: seo.description });
    return { ...head, scripts: faqScript(featurePage("stocks").faq, locale) };
  },
  component: stocksPage,
});

function stocksPage() {
  return <FeaturePage content={featurePage("stocks")} />;
}
